window.axios = require('axios');
import Vue from 'vue';
import Search from './components/Search.vue';
import Callbackform from './components/Callbackform.vue';
import Contactform from './components/Contactform.vue';
import Requestformte from './components/forms/FormTc.vue';
import Requestformop from './components/forms/FormOp.vue';
import Requestformmte from './components/forms/FormMte.vue';
import Requestformdf from './components/forms/FormDF.vue';
import Requestformtv from './components/forms/FormTV.vue';
import Requestformasu from './components/forms/FormASU.vue';
import Requestformcon from "./components/forms/FormConnectors.vue"
import Mainform from './components/Main.vue';
import RequestBox from './components/RequestBox.vue';
import Qmdashboard from "./components/qm-dashboard.vue";
import Deliverychart from "./components/DeliveryChart.vue";
import Responsechart from "./components/ResponseChart.vue";
import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

Vue.config.productionTip = false;

new Vue({
    components: {
        Search,
        Callbackform,
        Contactform,
        Qmdashboard,
        Requestformte,
        Requestformop,
        Requestformmte,
        Requestformcon,
        Requestformdf,
        Mainform,
        Deliverychart,
        Responsechart,
        Requestformtv,
        Requestformasu,
        RequestBox,
    },
}).$mount('#app');

/*
import hljs from 'highlight.js/lib/core';

// Syntax highlighting
hljs.registerLanguage('bash', require('highlight.js/lib/languages/bash'));
hljs.registerLanguage('css', require('highlight.js/lib/languages/css'));
hljs.registerLanguage('html', require('highlight.js/lib/languages/xml'));
hljs.registerLanguage('javascript', require('highlight.js/lib/languages/javascript'));
hljs.registerLanguage('json', require('highlight.js/lib/languages/json'));
hljs.registerLanguage('markdown', require('highlight.js/lib/languages/markdown'));
hljs.registerLanguage('php', require('highlight.js/lib/languages/php'));
hljs.registerLanguage('scss', require('highlight.js/lib/languages/scss'));
hljs.registerLanguage('yaml', require('highlight.js/lib/languages/yaml'));

document.querySelectorAll('pre code').forEach((block) => {
    hljs.highlightBlock(block);
});

*/